<template>
  <!-- 这里只用来展示一天的倒计时 -->
  <div class="count-down-box" v-if="!flag">
    <div class="time">
      <span :class="['cd-text', { 'have-bg': haveBg }]">{{ hour }}</span>
      <span class="space-mark">:</span>
      <span :class="['cd-text', { 'have-bg': haveBg }]">{{ minutes }}</span>
      <span class="space-mark">:</span>
      <span :class="['cd-text', { 'have-bg': haveBg }]">{{ seconds }}</span>
    </div>
    <div class="append-text">后过期</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
      delay: 1000,
      timer: null,
      hour: '',
      minutes: '',
      seconds: '',
    };
  },
  props: {
    endTime: {
      type: String,
    },
    haveBg: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.endTime) {
      this.timeDown();
      setInterval(() => {
        this.timeDown();
      }, this.delay);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    timeDown() {
      let formatDate = '';
      if (this.endTime) {
        formatDate = this.endTime.replace(/-/g, '/');
      }
      const endTime = new Date(`${formatDate} 23:59:59 GMT+8`);
      const nowTime = new Date();
      const leftTime = Math.max(0, parseInt(
        (endTime.getTime() - nowTime.getTime()) / 1000,
        0,
      ));
      const d = parseInt(leftTime / (24 * 60 * 60), 10);
      const h = this.formatTime(parseInt((leftTime / (60 * 60)) % 24, 10));
      const m = this.formatTime(parseInt((leftTime / 60) % 60, 10));
      const s = this.formatTime(parseInt(leftTime % 60, 10));
      if (leftTime <= 0) {
        this.flag = true;
      }
      if (d <= 1) {
        this.hour = h;
        this.minutes = m;
        this.seconds = s;
        this.flag = false;
      }
    },
    formatTime(time) {
      return time > 9 ? time : `0${time}`;
    },
  },
};
</script>
<style lang="less" scoped>
.count-down-box {
  display: flex;
  align-items: center;
  .time {
    font-weight: 400;
    padding-right: 4px;
    min-width: 70px;
    height: 19px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2px;
    .cd-text {
      color: #ff6464;
      font-size: 14px;
    }
    .have-bg {
      font-size: 12px;
      min-width: 19px;
      min-height: 16px;
      line-height: 16px;
      text-align: center;
      background: #ff6464;
      border-radius: 2px;
      color: #fff;
    }
    .space-mark {
      color: #ff6464;
    }
  }
  .append-text {
    font-size: 13px;
    color: #ff6464;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/count-down.vue